import DetailsClaim from "./DetailsClaim";
export default DetailsClaim;
